import React from 'react';

const Map = () => (
  <iframe
    id="map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1836.7880760663613!2d29.781739215801466!3d62.58908865252848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469b8730fe02c6d5%3A0xe45b22da12aafe95!2sKosmetologipalvelut%20Niina%20Varis!5e0!3m2!1sfi!2sfi!4v1606664183511!5m2!1sfi!2sfi"
    width="100%"
    height="300"
    frameBorder="0"
    style={{ border: 0 }}
    allowFullScreen=""
    aria-hidden="false"
    tabIndex="0"
    title="map"
  ></iframe>
);

export default Map;
